<header class="panel-header panel-header-compact">
  <h1>Exercise Objectives</h1>
  <p>Define what the organization hopes to test or achieve.</p>
</header>

<div class="scope-form">
  <section class="scope-section">
    <h2>Predefined Objectives</h2>

    <div class="chip-group participant-chip-group">
      <button
        type="button"
        class="selection-chip participant-chip"
        *ngFor="let objective of objectiveOptions"
        [class.selected]="isObjectiveSelected(objective.id)"
        (click)="toggleObjectiveSelection(objective.id)"
      >
        {{ objective.label }}
      </button>
    </div>
  </section>

  <section class="scope-section custom-objectives-section">
    <h2>Custom Objectives</h2>

    <div class="step-four-custom-controls">
      <input
        type="text"
        [value]="customObjectiveInput"
        placeholder="e.g Acme Healthcare Group, City of Guadalajara (government)"
        (input)="updateCustomObjectiveInput($event)"
        (keydown)="handleKeyDown($event)"
      />

      <button
        type="button"
        class="objective-add-button"
        (click)="addCustomObjective()"
        [disabled]="!customObjectiveInput.trim()"
      >
        Add
      </button>
    </div>

    <div
      class="chip-group participant-chip-group"
      *ngIf="customObjectives.length > 0"
    >
      <button
        type="button"
        class="selection-chip participant-chip"
        *ngFor="let objective of customObjectives"
        [class.selected]="isObjectiveSelected(objective.id)"
        (click)="toggleObjectiveSelection(objective.id)"
      >
        {{ objective.label }}
      </button>
    </div>
  </section>
</div>
